import api from "../services/authService";

/**
 * Document search / listing for the Search page and the mobile matter
 * view (Mobile DMS v1, Phase 4).
 *
 * Backed by `GET /api/documents/` (documents/views/document.py) —
 * name / category / file-type / path search, optional matter scoping,
 * DRF page-number pagination.
 */
export const searchDocumentsAPI = async ({
  query = "",
  matterId = null,
  page = 1,
  pageSize = 25,
  sortBy = "added_on",
  sortDirection = "desc",
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
    sort_by: sortBy,
    sort_direction: sortDirection,
  });
  if (query) params.set("search", query);
  if (matterId != null && matterId !== "") {
    params.set("matter_id", String(matterId));
  }
  const response = await api.get(`/documents/?${params.toString()}`, {
    timeout: 20000,
  });
  return response;
};
